import React, { useEffect } from 'react';
import { InputTextArea } from '@brokerbay/elements-web';
import { AccessOptionProps } from '../../types';

const Key: React.FC<AccessOptionProps> = ({
  showingsConfig,
  showValidationError,
  setShowingsConfig,
  setIsValid,
}) => {
  const isDetailsFilled = Boolean(showingsConfig.instructions.key?.details);

  useEffect(() => {
    setIsValid(isDetailsFilled);
  }, [isDetailsFilled, setIsValid]);

  return (
    <div>
      <InputTextArea
        label="Access instructions"
        dataCy="showing-notification-key-instructions"
        required
        minHeight={100}
        value={showingsConfig.instructions.key?.details || ''}
        onChange={value =>
          setShowingsConfig(prev => ({
            ...prev,
            instructions: {
              ...prev.instructions,
              key: {
                ...(prev.instructions.key || {}),
                details: value,
              },
            },
          }))
        }
        error={
          showValidationError && !isDetailsFilled
            ? 'Details are required'
            : undefined
        }
      />
    </div>
  );
};

export default Key;
